import Vue from 'vue';
import Router from 'vue-router';
import checkout from '@/components/checkout';
import checkoutFail from '@/components/checkout-fail';
import codeRedeem from '@/components/code-redeem';
import codeRedeemLanding from '@/components/code-redeem-landing';
import codeRedeemSuccess from '@/components/code-redeem-success';
import purchase from '@/components/purchase';
import redeemBalance from '@/components/purchase/redeem-balance';
import purchaseMaintenance from '@/components/purchase/result/maintenance';
import purchaseFailed from '@/components/purchase/result/failed';
import purchaseResult from '@/components/purchase/result';
import steamResult from '@/components/steam-result';
import inGameOrder from '@/components/in-game/order';
import inGameResult from '@/components/in-game/result';
import store from '../store';
import i18n from '@/plugins/i18n';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/checkout/',
	routes: [
		{
			path: '/:locale',
			name: 'checkout',
			component: checkout,
			props: true,
		},
		{
			path: '/:locale/code-redeem',
			name: 'code-redeem',
			component: codeRedeem,
			props: true,
		},
		{
			path: '/:locale/code-redeem/:gameName',
			name: 'code-redeem-landing',
			component: codeRedeemLanding,
			props: true,
		},
		{
			path: '/:locale/code-redeem-success',
			name: 'code-redeem-success',
			component: codeRedeemSuccess,
			props: true,
		},
		{
			path: '/:locale/result',
			name: 'purchase-result',
			component: purchaseResult,
			props: true,
		},
		{
			// BE is redirecting to this result page for the steam nx purchase (maplestory, mabinogi, vindictus)
			path: '/:locale/steam-result',
			name: 'steam-result',
			component: steamResult,
			props: true,
			beforeEnter(to, from, next) {
				store.commit('setAppType', 'steam'); // for displaying proper background color and theme image when returning from the steam side
				next();
			},
		},
		{
			path: '/:locale/fail',
			name: 'checkout-failure',
			component: checkoutFail,
			props: true,
		},
		{
			path: '/:locale/purchase',
			name: 'purchase',
			component: purchase,
			props: true,
		},
		{
			path: '/:locale/failed',
			name: 'purchase-failed',
			component: purchaseFailed,
			props: true,
		},
		{
			path: '/:locale/maintenance',
			name: 'purchase-maintenance',
			component: purchaseMaintenance,
			props: true,
		},
		{
			path: '/:locale/redeem',
			name: 'redeem-balance',
			component: redeemBalance,
			props: true,
		},
		// in game payment revamp routes:
		{
			path: '/:locale/in-game/order',
			name: 'in-game-order',
			component: inGameOrder,
			props: true,
		},
		{
			path: '/:locale/in-game/purchase',
			name: 'in-game-purchase',
			component: purchase,
			props: true,
		},
		{
			path: '/:locale/in-game/result',
			name: 'in-game-result',
			component: inGameResult,
			props: true,
		},
		{
			path: '/:locale/in-game/failed',
			name: 'in-game-purchase-failed',
			component: inGameResult,
			props: true,
		},
	],
});

router.beforeEach((to, from, next) => {
	const appType = to.query.app_type,
		prodId = to.query.product_id,
		sandBoxMode = to.query.sandbox,
		service_type = to.query.service_type,
		locale = to.params.locale;

	if (locale && i18n.locale !== locale) i18n.locale = locale; // set the language in the proper place instead of created from the main.js vue mixin

	if (appType) {
		store.commit('setAppType', appType);
	}
	if (prodId) {
		Vue.cookie.set('CommerceProdId', prodId);
	}
	if (sandBoxMode === 'true') {
		store.commit('enableSandboxMode');
	}
	if (service_type === 'shop') {
		store.commit('setShop');
	}

	document.body.className = store.state.appType.toLowerCase();
	next();
});

export default router;
